import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export default class IdentifyMapper extends Mapper {
  constructor({config}) {
    super()

    this._config = config
    this._trackingUserIdPrefix = this._config.get('tracking').SDRN_BASE
  }

  /**
   * @method
   * @private
   */
  _removeNullProperties = obj => {
    const properties = Object.keys(obj)

    return properties.reduce((acc, key) => {
      const property = obj[key]
      const hasToBeAdded = property !== undefined && property !== null
      if (hasToBeAdded) acc[key] = property
      return acc
    }, {})
  }

  /**
   * @param {Object} params
   * @param {Object} params.user
   */
  map = ({user: {userId: id, name, avatar, email, isEmailConfirmed, province} = {}}) => {
    const hasUserId = Boolean(id)
    const userId = hasUserId ? `${this._trackingUserIdPrefix}${id}` : null
    const data = this._removeNullProperties({
      userId,
      avatar,
      username: name,
      email,
      email_confirmed: isEmailConfirmed,
      user_province: province
    })

    return {
      ...(hasUserId && {userId}),
      data
    }
  }
}
